/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchMessageRequest } from '../models';
// @ts-ignore
import type { BatchMessageResponse } from '../models';
// @ts-ignore
import type { LocaleInfo } from '../models';
// @ts-ignore
import type { LocaleResponse } from '../models';
// @ts-ignore
import type { MessageResponse } from '../models';
/**
 * LocalesApi - axios parameter creator
 * @export
 */
export const LocalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns list of supported languages/locales
         * @summary Get available locales
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableLocales: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns multiple translated messages for the specified keys and locale
         * @summary Get multiple translated messages
         * @param {BatchMessageRequest} batchMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchMessages: async (batchMessageRequest: BatchMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchMessageRequest' is not null or undefined
            assertParamExists('getBatchMessages', 'batchMessageRequest', batchMessageRequest)
            const localVarPath = `/api/locales/messages/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current locale information based on Accept-Language header
         * @summary Get current locale
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentLocale: async (acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locales/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns translated message for the specified key and locale
         * @summary Get translated message
         * @param {string} key 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: async (key: string, locale?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getMessage', 'key', key)
            const localVarPath = `/api/locales/messages/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalesApi - functional programming interface
 * @export
 */
export const LocalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns list of supported languages/locales
         * @summary Get available locales
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableLocales(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocaleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableLocales(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalesApi.getAvailableLocales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns multiple translated messages for the specified keys and locale
         * @summary Get multiple translated messages
         * @param {BatchMessageRequest} batchMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchMessages(batchMessageRequest: BatchMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchMessages(batchMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalesApi.getBatchMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns current locale information based on Accept-Language header
         * @summary Get current locale
         * @param {string} [acceptLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentLocale(acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocaleInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentLocale(acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalesApi.getCurrentLocale']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns translated message for the specified key and locale
         * @summary Get translated message
         * @param {string} key 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessage(key: string, locale?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessage(key, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalesApi.getMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocalesApi - factory interface
 * @export
 */
export const LocalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalesApiFp(configuration)
    return {
        /**
         * Returns list of supported languages/locales
         * @summary Get available locales
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableLocales(options?: RawAxiosRequestConfig): AxiosPromise<LocaleResponse> {
            return localVarFp.getAvailableLocales(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns multiple translated messages for the specified keys and locale
         * @summary Get multiple translated messages
         * @param {LocalesApiGetBatchMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchMessages(requestParameters: LocalesApiGetBatchMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchMessageResponse> {
            return localVarFp.getBatchMessages(requestParameters.batchMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current locale information based on Accept-Language header
         * @summary Get current locale
         * @param {LocalesApiGetCurrentLocaleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentLocale(requestParameters: LocalesApiGetCurrentLocaleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocaleInfo> {
            return localVarFp.getCurrentLocale(requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns translated message for the specified key and locale
         * @summary Get translated message
         * @param {LocalesApiGetMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage(requestParameters: LocalesApiGetMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.getMessage(requestParameters.key, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getBatchMessages operation in LocalesApi.
 * @export
 * @interface LocalesApiGetBatchMessagesRequest
 */
export interface LocalesApiGetBatchMessagesRequest {
    /**
     * 
     * @type {BatchMessageRequest}
     * @memberof LocalesApiGetBatchMessages
     */
    readonly batchMessageRequest: BatchMessageRequest
}

/**
 * Request parameters for getCurrentLocale operation in LocalesApi.
 * @export
 * @interface LocalesApiGetCurrentLocaleRequest
 */
export interface LocalesApiGetCurrentLocaleRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalesApiGetCurrentLocale
     */
    readonly acceptLanguage?: string
}

/**
 * Request parameters for getMessage operation in LocalesApi.
 * @export
 * @interface LocalesApiGetMessageRequest
 */
export interface LocalesApiGetMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalesApiGetMessage
     */
    readonly key: string

    /**
     * 
     * @type {string}
     * @memberof LocalesApiGetMessage
     */
    readonly locale?: string
}

/**
 * LocalesApi - object-oriented interface
 * @export
 * @class LocalesApi
 * @extends {BaseAPI}
 */
export class LocalesApi extends BaseAPI {
    /**
     * Returns list of supported languages/locales
     * @summary Get available locales
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalesApi
     */
    public getAvailableLocales(options?: RawAxiosRequestConfig) {
        return LocalesApiFp(this.configuration).getAvailableLocales(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns multiple translated messages for the specified keys and locale
     * @summary Get multiple translated messages
     * @param {LocalesApiGetBatchMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalesApi
     */
    public getBatchMessages(requestParameters: LocalesApiGetBatchMessagesRequest, options?: RawAxiosRequestConfig) {
        return LocalesApiFp(this.configuration).getBatchMessages(requestParameters.batchMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current locale information based on Accept-Language header
     * @summary Get current locale
     * @param {LocalesApiGetCurrentLocaleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalesApi
     */
    public getCurrentLocale(requestParameters: LocalesApiGetCurrentLocaleRequest = {}, options?: RawAxiosRequestConfig) {
        return LocalesApiFp(this.configuration).getCurrentLocale(requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns translated message for the specified key and locale
     * @summary Get translated message
     * @param {LocalesApiGetMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalesApi
     */
    public getMessage(requestParameters: LocalesApiGetMessageRequest, options?: RawAxiosRequestConfig) {
        return LocalesApiFp(this.configuration).getMessage(requestParameters.key, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}

